import React, { useState } from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";

// Import project images
import tisImg from "../../project images/tis-edu-pk-19.png";
import geminiImg from "../../project images/geminiesolutions-8.png";
import aamlImg from "../../project images/aaml-co-uk.png";
import datalogzImg from "../../project images/datalogz-io-5.png";
import temocImg from "../../Assets/Projects/leaf.png"; // Placeholder - no temoc image
import reviewRadarImg from "../../project images/reviewradar-ai-15.png";
import aiBannersImg from "../../project images/ai-banners.png";
import rfcImg from "../../project images/rfcofficial-io-16.png";
import styleMoneyImg from "../../project images/getstylemoney-9.png";
import finantaImg from "../../project images/finanta-org-6.png";
import betbitImg from "../../project images/betbitsports-3.png";
import nohesiImg from "../../project images/nohesi-gg-14.png";
import urduDiaryImg from "../../project images/my-daily-diary.png";
import spouseImg from "../../project images/spouse-accountability.png";
import goldmanImg from "../../project images/goldman-lawyers-10.png";
import sprintlawImg from "../../project images/sprintlaw-au-18.png";
import bsmImg from "../../project images/bsmlaw-au-4.png";
import fortMedicalImg from "../../project images/fortmedicalbilling-us-7.png";
import meddybillImg from "../../project images/meddybill-11.png";
import myfcImg from "../../project images/myfcbilling-13.png";
import alnaseebImg from "../../project images/alnaseeb-pk-2.png";
import erpcrmImg from "../../project images/erpcrm.png";
import jampropImg from "../../project images/jamprop.png";
import jmaicaImg from "../../project images/jamaica_land.png";

function Projects() {
  const [selectedCategory, setSelectedCategory] = useState("All");

  const categories = [
    "All",
    "Education & ERP",
    "Energy & Industrial",
    "Real Estate & Hospitality",
    "AI, SaaS & Data",
    "FinTech & Web3",
    "Legal Services",
    "Healthcare & Medical",
    "E-Commerce & Others"
  ];

  // All projects data
  const allProjects = [
    // Education & ERP - Flagship Projects
    {
      id: 1,
      category: "Education & ERP",
      imgPath: erpcrmImg,
      title: "Enterprise ERP/CRM System",
      industry: "Enterprise SaaS / Multi-Tenant Platform",
      description: "Production-ready multi-tenant platform with real-time dashboards, customer and sales management, attendance tracking, automated audit logs, IP whitelisting, rate limiting, PDF invoice and quote generation, localization, and enterprise-grade security. Complete ownership of frontend, backend, and system architecture.",
      demoLink: "https://aethonlifeinsurance.com:9000/"
    },
    {
      id: 2,
      category: "Education & ERP",
      imgPath: jampropImg,
      title: "AI Property Management CRM (JamProp)",
      industry: "Real Estate SaaS / AI-Powered",
      description: "End-to-end deal pipelines, automated document generation, analytics dashboards, and AI-assisted workflows built to streamline property and operations management. Scalable, production-ready system designed for real business operations.",
      demoLink: ""
    },
    {
      id: 3,
      category: "Education & ERP",
      imgPath: jmaicaImg,
      title: "Real Estate Deal CRM (Full-Stack)",
      industry: "Real Estate / Deal Management",
      description: "Production-ready CRM built with FastAPI (60+ endpoints), JWT authentication, React dashboards, structured data pipelines, deal analysis engines, and export-ready reporting. Complete end-to-end ownership of architecture and delivery.",
      demoLink: "http://185.207.250.37/"
    },
    {
      id: 4,
      category: "Education & ERP",
      imgPath: tisImg,
      title: "The International School (TIS)",
      industry: "Education / EdTech",
      description: "Designed and developed a complete school ERP and Learning Management System covering student registration, teacher management, enrollment workflows, attendance tracking, and LMS modules. The platform digitizes academic and administrative operations end-to-end.",
      demoLink: "https://www.tis.edu.pk/"
    },
    // Energy & Industrial
    {
      id: 5,
      category: "Energy & Industrial",
      imgPath: geminiImg,
      title: "Gemini E Solutions",
      industry: "Energy Management / Smart Facilities",
      description: "Enterprise energy management platform developed in collaboration with electrical engineers. The system analyzes power intake for large facilities, manages internal electrical systems (lighting, HVAC, distribution), generates annual energy reports, and provides actionable insights to reduce energy consumption and operational costs.",
      demoLink: "https://geminiesolutions.com/"
    },
    // Real Estate & Hospitality
    {
      id: 6,
      category: "Real Estate & Hospitality",
      imgPath: aamlImg,
      title: "AAML (UK)",
      industry: "Property Management / Hospitality",
      description: "Developed the public website and internal management systems for a UK-based property company specializing in Airbnb hospitality rentals and property acquisition. The platform supports operational workflows, property portfolios, and business scalability.",
      demoLink: "https://www.aaml.co.uk/"
    },
    // AI, SaaS & Data
    {
      id: 7,
      category: "AI, SaaS & Data",
      imgPath: datalogzImg,
      title: "Datalogz",
      industry: "Data & Analytics",
      description: "Data analytics and insights platform enabling businesses to transform raw data into actionable intelligence through dashboards and reporting systems.",
      demoLink: "https://www.datalogz.io/"
    },
    {
      id: 8,
      category: "AI, SaaS & Data",
      imgPath: temocImg,
      title: "Temoc",
      industry: "Web3 / B2B SaaS",
      description: "AI-driven B2B platform enabling businesses and creators to manage digital engagement, tokenized access, and Web3-native monetization models.",
      demoLink: "https://temoc.io/"
    },
    {
      id: 9,
      category: "AI, SaaS & Data",
      imgPath: reviewRadarImg,
      title: "ReviewRadar AI",
      industry: "AI / Customer Intelligence",
      description: "Multi-tenant AI automation platform that aggregates customer reviews across multiple sources and applies sentiment analysis to generate actionable insights for businesses.",
      demoLink: "https://www.reviewradar-ai.com/"
    },
    {
      id: 10,
      category: "AI, SaaS & Data",
      imgPath: aiBannersImg,
      title: "AI Banners Generator",
      industry: "AI / Marketing Automation",
      description: "AI-powered tool for generating dynamic marketing banners, enabling rapid content creation for digital campaigns.",
      demoLink: "https://ai-banners.vercel.app/"
    },
    // FinTech & Web3
    {
      id: 11,
      category: "FinTech & Web3",
      imgPath: rfcImg,
      title: "RFC Official",
      industry: "Crypto / Blockchain",
      description: "React and Next.js-based crypto education and blockchain ecosystem platform supporting digital asset awareness, engagement, and community growth.",
      demoLink: "https://www.rfcofficial.io/"
    },
    {
      id: 12,
      category: "FinTech & Web3",
      imgPath: styleMoneyImg,
      title: "StyleMoney",
      industry: "Creator Economy / Web3",
      description: "Creator monetization platform enabling influencers and fashion creators to earn through digital engagement, social commerce, and blockchain-powered reward systems.",
      demoLink: "https://www.getstylemoney.com/"
    },
    {
      id: 13,
      category: "FinTech & Web3",
      imgPath: finantaImg,
      title: "Finanta",
      industry: "FinTech",
      description: "FinTech organization platform supporting innovation, collaboration, and growth within financial technology ecosystems.",
      demoLink: "https://finanta.org/"
    },
    {
      id: 14,
      category: "FinTech & Web3",
      imgPath: betbitImg,
      title: "BetBit Sports",
      industry: "Sports Betting",
      description: "Online sports betting platform offering interactive wagering experiences, odds management, and real-time sports engagement.",
      demoLink: "https://betbitsports.com/"
    },
    // E-Commerce & Others
    {
      id: 15,
      category: "E-Commerce & Others",
      imgPath: nohesiImg,
      title: "Nohesi CRM",
      industry: "CRM / Gaming Communities",
      description: "Custom CRM platform designed for gaming and online communities, enabling user engagement, relationship tracking, and community management.",
      demoLink: "https://nohesi.gg/"
    },
    {
      id: 16,
      category: "E-Commerce & Others",
      imgPath: urduDiaryImg,
      title: "Urdu Diary App",
      industry: "Productivity",
      description: "Personal journaling and diary application with Urdu language support, featuring dashboards and secure entry management.",
      demoLink: "https://my-daily-diary.vercel.app/dashboard"
    },
    {
      id: 17,
      category: "E-Commerce & Others",
      imgPath: spouseImg,
      title: "Spouse Accountability App",
      industry: "Lifestyle / Productivity",
      description: "Accountability and goal-tracking web application designed to support shared responsibility and progress tracking.",
      demoLink: "https://spouse-accountability.vercel.app/"
    },
    // Legal Services
    {
      id: 18,
      category: "Legal Services",
      imgPath: goldmanImg,
      title: "Goldman Lawyers",
      industry: "Legal Services",
      description: "Corporate law firm website showcasing legal services, practice areas, and client engagement workflows.",
      demoLink: "https://goldman-lawyers.com/"
    },
    {
      id: 19,
      category: "Legal Services",
      imgPath: sprintlawImg,
      title: "Sprintlaw",
      industry: "Legal Tech",
      description: "Digital legal services platform offering fixed-fee legal solutions for startups and small businesses in Australia.",
      demoLink: "https://sprintlaw.com.au/"
    },
    {
      id: 20,
      category: "Legal Services",
      imgPath: bsmImg,
      title: "BSM Law",
      industry: "Legal Services",
      description: "Professional law firm website supporting client onboarding and service presentation.",
      demoLink: "https://bsmlaw.com.au/"
    },
    // Healthcare & Medical
    {
      id: 21,
      category: "Healthcare & Medical",
      imgPath: fortMedicalImg,
      title: "Fort Medical Billing",
      industry: "Healthcare / Medical Billing",
      description: "Medical billing and revenue cycle management platform supporting claims processing, coding, and healthcare financial operations.",
      demoLink: "https://fortmedicalbilling.us/"
    },
    {
      id: 22,
      category: "Healthcare & Medical",
      imgPath: meddybillImg,
      title: "MeddyBill",
      industry: "Healthcare / RCM",
      description: "Medical billing and practice management platform designed to streamline payments, claims, and healthcare workflows.",
      demoLink: "https://www.meddybill.com/"
    },
    {
      id: 23,
      category: "Healthcare & Medical",
      imgPath: myfcImg,
      title: "MyFC Billing",
      industry: "Healthcare / Medical Finance",
      description: "Billing and revenue management solution tailored for medical and clinical service providers.",
      demoLink: "https://myfcbilling.com/"
    },
    // E-Commerce
    {
      id: 24,
      category: "E-Commerce & Others",
      imgPath: alnaseebImg,
      title: "Al-Naseeb",
      industry: "E-Commerce",
      description: "Online commerce platform for premium food and dry fruit products with order management and customer fulfillment workflows.",
      demoLink: "https://alnaseeb.com.pk/"
    }
  ];

  // Filter projects based on selected category
  const filteredProjects = selectedCategory === "All" 
    ? allProjects 
    : allProjects.filter(project => project.category === selectedCategory);

  return (
    <Container fluid className="project-section">
      <Particle />
      <Container style={{ position: "relative", zIndex: 1 }}>
        <h1 className="project-heading">
          Our <strong className="purple">Portfolio </strong>
        </h1>
        <p style={{ color: "white" }}>
          Production-grade ERP, CRM, SaaS, and AI automation platforms delivered across diverse industries.
        </p>

        {/* Category Filter */}
        <Row style={{ justifyContent: "center", paddingBottom: "30px", paddingTop: "20px" }}>
          <Col md={12} style={{ display: "flex", justifyContent: "center", flexWrap: "wrap", gap: "10px", position: "relative", zIndex: 10 }}>
            {categories.map((category) => (
              <Button
                key={category}
                variant={selectedCategory === category ? "primary" : "outline-primary"}
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  console.log("Clicking category:", category);
                  setSelectedCategory(category);
                }}
                style={{
                  margin: "5px",
                  borderRadius: "20px",
                  padding: "8px 20px",
                  fontSize: "0.9em",
                  transition: "all 0.3s ease",
                  cursor: "pointer",
                  position: "relative",
                  zIndex: 10
                }}
              >
                {category}
              </Button>
            ))}
          </Col>
        </Row>

        {/* Display current filter and count */}
        <Row style={{ justifyContent: "center", paddingBottom: "20px" }}>
          <Col md={12} style={{ textAlign: "center" }}>
            <p style={{ color: "rgb(155 126 172)", fontSize: "1.1em" }}>
              {selectedCategory === "All" 
                ? `Showing all ${filteredProjects.length} projects` 
                : `${selectedCategory}: ${filteredProjects.length} project${filteredProjects.length !== 1 ? 's' : ''}`}
            </p>
          </Col>
        </Row>

        {/* Projects Display */}
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          {filteredProjects.map((project) => (
            <Col md={4} className="project-card" key={project.id}>
              <ProjectCard
                imgPath={project.imgPath}
                title={project.title}
                industry={project.industry}
                description={project.description}
                demoLink={project.demoLink}
              />
            </Col>
          ))}
        </Row>

        {filteredProjects.length === 0 && (
          <Row>
            <Col md={12}>
              <p style={{ color: "white", textAlign: "center", padding: "50px" }}>
                No projects found in this category.
              </p>
            </Col>
          </Row>
        )}
      </Container>
    </Container>
  );
}

export default Projects;
